const fonts = {
  heading: 'Bebas Neue, sans-serif',
  body: 'Montserrat, sans-serif',
};

export default fonts;
